import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { HashRouter } from "react-router-dom";
import { App } from "./pages/App";
import { robustLMSExit } from "./store/globalStore";
import "./index.css";

// Flag para prevenir doble ejecución
let hasExitedAlready = false;

function safeExit() {
  if (hasExitedAlready) return;
  hasExitedAlready = true;
  robustLMSExit();
}

// Registro global de cierre
window.addEventListener("beforeunload", safeExit);
window.addEventListener("unload", safeExit);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <HashRouter>
      <App />
    </HashRouter>
  </StrictMode>,
);
